export const MAIN_CLASS_NAME = 'asr-providers-page';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const TOOLBAR_CLASS_NAME = `${CONTENT_CLASS_NAME}__toolbar`;
export const NAME_CELL_CLASS_NAME = `${CONTENT_CLASS_NAME}__name-cell`;
export const TYPE_CELL_CLASS_NAME = `${CONTENT_CLASS_NAME}__type-cell`;
export const PAGINATION_CLASS_NAME = `${MAIN_CLASS_NAME}__pagination`;

export const ASR_PROVIDERS_PAGE_SIZE = 30;
export const TOOLTIP_MOUSE_DELAY = 0.5;

export const TRANSLATION_GROUP_PREFIX = 'ASR: Providers: Page:';
